var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatches5Stroked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1C7.72899 1 1 7.72899 1 16C1 24.271 7.72899 31 16 31C24.271 31 31 24.271 31 16C31 7.72899 24.271 1 16 1ZM16 29.5612C8.52237 29.5612 2.43885 23.4777 2.43885 16C2.43885 8.5223 8.52237 2.43885 16 2.43885C23.4776 2.43885 29.5612 8.5223 29.5612 16C29.5612 23.4777 23.4776 29.5612 16 29.5612Z",
    fill: "#969EB1",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9219 15.4317H23.349C23.8723 15.4317 24.2965 15.8559 24.2965 16.3792C24.2965 16.9025 23.8723 17.3267 23.349 17.3267H15.9475C15.4875 17.3267 15.104 16.9988 15.018 16.564C15.0064 16.5198 15 16.4749 15 16.4298V16.3792V7.46094C15 6.9305 15.4305 6.5 15.9609 6.5C16.4914 6.5 16.9219 6.9305 16.9219 7.46094V15.4317Z",
    fill: "#969EB1",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatches5Stroked);
export default __webpack_public_path__ + "static/media/watches-5-stroked.b41495e6812c26152b5697c0395c325a.svg";
export { ForwardRef as ReactComponent };